'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var qwest = _interopRequireWildcard(require("qwest"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _TextInput = _interopRequireDefault(require("Components/Forms/Elements/TextInput"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
var _handleChange = _interopRequireDefault(require("Components/Forms/Functions/handleChange"));
var _Loader = _interopRequireDefault(require("Pure/Loader"));
var _Link = _interopRequireDefault(require("Pure/Link"));
var _Routes = require("Shared/Routes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
let app = window.app;
const DEFAULT_ERROR = 'Connexion impossible, veuillez rententer ' + 'ultérieurement.';
class LoginForm extends _react.Component {
  state = {
    status_messages: {},
    error: undefined
  };
  handleChange = _handleChange.default.bind(this);
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    if (app.state.form_error) {
      component.setState({
        error: app.state.form_error
      });
    }
  }
  login = e => {
    const component = this,
      props = this.props,
      state = this.state;
    e.preventDefault();
    component.setState({
      loading: true
    });
    qwest.post('/login', {
      login: state.email,
      password: state.password
    }).then(function (xhr, response) {
      // Update user permissions now that user is connected
      app.emit({
        event: 'sessionNeedsRefresh',
        source: 'login'
      });
      if (response.user.roles.includes('admin') || response.user.roles.includes('agent') || response.user.roles.includes('accompanist')) {
        app.navigateTo((0, _Routes.URL)('AdminCandidatesDashboard'));
      } else if (response.user.roles.includes('candidate')) {
        const link = (0, _Routes.URL)('CandidateAccount');
        app.navigateTo(link);
      } else if (response.user.roles.includes('companies-manager')) {
        app.navigateTo((0, _Routes.URL)('AdminCompaniesDashboard'));
      } else {
        const link = '/mon-compte-entreprise';
        app.navigateTo(link);
      }
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response,
          error: DEFAULT_ERROR
        })
      });
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const status = (0, _getFormStatus.default)(state);
    const loader = state.loading === true ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
      className: "c-loader",
      bemit: ['white', 'bg-primary']
    }) : undefined;
    let output = /*#__PURE__*/_react.default.createElement("form", {
      method: "POST",
      action: "/login",
      className: "login-page__form",
      onSubmit: component.login
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['email'],
      name: "email",
      label: "E-mail",
      type: "email",
      autocomplete: "current-email",
      status: state.status_messages
    }), /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['password'],
      name: "password",
      label: "Mot de passe",
      type: "password",
      className: "u-margin-top-10",
      autocomplete: "current-password",
      status: state.status_messages
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "u-full-width u-text-right u-margin-top-20"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      color: "secondary",
      size: "small",
      href: (0, _Routes.URL)('PasswordRecovery'),
      component: props => /*#__PURE__*/_react.default.createElement(_Link.default, props)
    }, "Mot de passe oubli\xE9\xA0?")), status, /*#__PURE__*/_react.default.createElement("div", {
      className: "u-full-width u-margin-top-25 u-text-center"
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "submit",
      className: "c-btn c-btn--blue"
    }, "Je me connecte", loader)));
    return output;
  }
}
exports.default = LoginForm;
